module.exports = __webpack_public_path__ + "static/media/15.136e3012.png";